import React, { useMemo } from "react";
import { FiArrowRight, FiCheck, FiMail, FiPackage } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import Button from "../components/common/Button";
import EmptyState from "../components/common/EmptyState";
import PageMeta from "../components/common/PageMeta";
import { formatCurrency } from "../config/siteConfig";

const OrderSuccessPage = () => {
  const location = useLocation();
  const order = useMemo(() => {
    if (location.state?.order) return location.state.order;
    try { return JSON.parse(window.sessionStorage.getItem("madezuno:last-order")); } catch { return null; }
  }, [location.state]);

  if (!order) {
    return <div className="order-success-page"><PageMeta title="Order Status" /><EmptyState title="No recent order found" description="Complete checkout first, or track an existing pantry order." actionLabel="Return to the pantry" actionTo="/shop" /></div>;
  }

  return (
    <div className="order-success-page">
      <PageMeta title="Order Confirmed" />
      <section className="order-success-card">
        <span className="order-success-card__icon"><FiCheck aria-hidden="true" /></span>
        <p className="eyebrow">Order confirmed</p>
        <h1>Your pantry box is on our table.</h1>
        <p>{`Thanks, ${order.customer.firstName}. We’ve received demo order ${order.id}.`}</p>
        <div className="order-success-card__summary"><span><small>Order number</small><strong>{order.id}</strong></span><span><small>Total</small><strong>{formatCurrency(order.totals.total)}</strong></span><span><small>Delivery</small><strong>{order.deliveryMethod === "express" ? "Express" : "Standard"}</strong></span></div>
        <div className="order-success-card__steps"><span><FiMail /><strong>Confirmation</strong><small>{order.customer.email}</small></span><span><FiPackage /><strong>Next</strong><small>We’ll pack the order in 1–2 business days.</small></span></div>
        <div className="order-success-card__actions"><Button to="/shop">Keep exploring <FiArrowRight /></Button><Button to="/recipes" variant="secondary">Find a recipe</Button></div>
      </section>
    </div>
  );
};

export default OrderSuccessPage;
